/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
const INITIAL_CONTEXT = {
  idle: {},
  GET_ABOUT_ME: {},
};

const MACHINE_CONFIG = {
  id: 'io.vlinder.platium-boilerplate.aboutMePage.aboutMe',
  initial: 'idle',
  context: INITIAL_CONTEXT,
  states: {
    idle: {
      entry: ['resetAction'],
      on: {
        START: { target: 'GET_ABOUT_ME' },
      },
    },
    GET_ABOUT_ME: {
      invoke: {
        id: 'getAboutMe',
        src: 'getAboutMe',
        onDone: {
          target: 'RENDER_ABOUT_ME',
          actions: ['successAction'],
        },
        onError: {
          target: 'RENDER_ABOUT_ME_ERROR',
          actions: ['failureAction'],
        },
      },
    },
    RENDER_ABOUT_ME: {
      on: {
        TRIGGER_REFRESH: {
          target: 'GET_ABOUT_ME',
        },
      },
    },
    RENDER_ABOUT_ME_ERROR: {
      type: 'final',
    },
  },
};

//Machine(MACHINE_CONFIG)

export { INITIAL_CONTEXT, MACHINE_CONFIG };
